// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.DotsMap_scroll__QNSSh::-webkit-scrollbar {
  height: 8px;
}
.DotsMap_scroll__QNSSh::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.DotsMap_scroll__QNSSh::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.DotsMap_DotsMap__KSrPu {
  height: 272px;
  position: relative;
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  -webkit-padding-end: 20px;
          padding-inline-end: 20px;
  position: absolute;
  width: 100%;
  z-index: 999;
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J .DotsMap_Filters__xWH4u {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J .DotsMap_Controls__FtiR2 {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J .DotsMap_Controls__FtiR2 .DotsMap_ControlsItem__Bsjym {
  cursor: pointer;
  z-index: 55;
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J .DotsMap_Controls__FtiR2 .DotsMap_ControlsItem__Bsjym:not(:last-of-type) {
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
  -webkit-border-end: 1px solid var(--borderColor);
          border-inline-end: 1px solid var(--borderColor);
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J .DotsMap_Controls__FtiR2 .DotsMap_ControlsItem__Bsjym svg g line {
  stroke: var(--mainColor) !important;
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J .DotsMap_Controls__FtiR2 .DotsMap_ControlsItem__Bsjym svg g path {
  stroke: var(--mainColor) !important;
}
.DotsMap_DotsMap__KSrPu .DotsMap_TopBar__K5N8J .DotsMap_Controls__FtiR2 div div div button svg path {
  fill: var(--mainColor) !important;
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 11px;
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 999;
  gap: 10px;
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj p {
  font-size: 10px !important;
  text-transform: capitalize;
  color: var(--tweetSubTitleColor);
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj div[class^=DotsMap_item] {
  width: 12px;
  height: 12px;
  -webkit-margin-start: 10px;
          margin-inline-start: 10px;
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj .DotsMap_item1__gLTey {
  background: rgba(255, 0, 0, 0.2);
  border: 1px solid rgb(255, 0, 0);
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj .DotsMap_item2__n56wU {
  background: rgba(158, 166, 65, 0.2);
  border: 1px solid rgb(158, 166, 65);
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj .DotsMap_item3__15B8n {
  background: rgba(255, 167, 0, 0.2);
  border: 1px solid rgb(255, 167, 0);
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj .DotsMap_item4__HplEh {
  background: rgba(124, 102, 217, 0.2);
  border: 1px solid rgb(124, 102, 217);
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj .DotsMap_item5__OIxpL {
  background: rgba(255, 0, 128, 0.2);
  border: 1px solid rgb(255, 0, 128);
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainer__jdlPj .DotsMap_item6__Nf58\\+ {
  background-color: #fafaf8;
  border: 1px solid rgb(79, 79, 79);
}
.DotsMap_DotsMap__KSrPu .DotsMap_itemsContainerInDetails__PO9El {
  justify-content: center;
}
body[dir=rtl] .DotsMap_DotsMap__KSrPu .DotsMap_itemsContainerInDetails__PO9El {
  -webkit-margin-start: 0;
          margin-inline-start: 0;
}
.DotsMap_DotsMap__KSrPu .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
  height: 272px;
}

.DotsMap_MapHeight__NOxz3 {
  height: 732px;
  margin-bottom: 30px;
}
.DotsMap_MapHeight__NOxz3 .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
  height: 732px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/DotsMap/DotsMap.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,aAAA;EACA,kBAAA;AAsDF;AApDE;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;UAAA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAsDJ;AArDI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAuDN;AArDI;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAuDN;AAtDM;EACE,eAAA;EACA,WAAA;AAwDR;AAvDQ;EACE,yBAAA;UAAA,wBAAA;EACA,gDAAA;UAAA,+CAAA;AAyDV;AArDY;EACE,mCAAA;AAuDd;AArDY;EACE,mCAAA;AAuDd;AA7CgB;EACE,iCAAA;AA+ClB;AAtCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;AAwCJ;AApCI;EACE,0BAAA;EACA,0BAAA;EACA,gCAAA;AAsCN;AApCI;EACE,WAAA;EACA,YAAA;EACA,0BAAA;UAAA,yBAAA;AAsCN;AApCI;EACE,gCAAA;EACA,gCAAA;AAsCN;AApCI;EACE,mCAAA;EACA,mCAAA;AAsCN;AAnCI;EACE,kCAAA;EACA,kCAAA;AAqCN;AAnCI;EACE,oCAAA;EACA,oCAAA;AAqCN;AAnCI;EACE,kCAAA;EACA,kCAAA;AAqCN;AAnCI;EACE,yBAAA;EACA,iCAAA;AAqCN;AAlCE;EAEE,uBAAA;AAmCJ;AAjCI;EACE,uBAAA;UAAA,sBAAA;AAmCN;AA/BI;EACE,aAAA;AAiCN;;AA5BA;EACE,aAAA;EACA,mBAAA;AA+BF;AA7BI;EACE,aAAA;AA+BN","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.DotsMap {\n  height: 272px;\n  position: relative;\n\n  .TopBar {\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: space-between;\n    padding-top: 20px;\n    padding-inline-end: 20px;\n    position: absolute;\n    width: 100%;\n    z-index: 999;\n    .Filters {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n    }\n    .Controls {\n      display: flex;\n      align-items: center;\n      justify-content: space-evenly;\n      .ControlsItem {\n        cursor: pointer;\n        z-index: 55;\n        &:not(:last-of-type) {\n          padding-inline-end: 10px;\n          border-inline-end: 1px solid var(--borderColor);\n        }\n        svg {\n          g {\n            line {\n              stroke: var(--mainColor) !important;\n            }\n            path {\n              stroke: var(--mainColor) !important;\n            }\n          }\n        }\n      }\n      div {\n        div {\n          div {\n            button {\n              svg {\n                path {\n                  fill: var(--mainColor) !important;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .itemsContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 11px;\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    z-index: 999;\n    gap: 10px;\n    // #{$rtl} & {\n    //   margin-inline-start: 10%;\n    // }\n    p {\n      font-size: 10px !important;\n      text-transform: capitalize;\n      color: var(--tweetSubTitleColor);\n    }\n    div[class^='DotsMap_item'] {\n      width: 12px;\n      height: 12px;\n      margin-inline-start: 10px;\n    }\n    .item1 {\n      background: rgba(255, 0, 0, 0.2);\n      border: 1px solid rgb(255, 0, 0);\n    }\n    .item2 {\n      background: rgba(158, 166, 65, 0.2);\n      border: 1px solid rgb(158, 166, 65);\n    }\n\n    .item3 {\n      background: rgba(255, 167, 0, 0.2);\n      border: 1px solid rgb(255, 167, 0);\n    }\n    .item4 {\n      background: rgba(124, 102, 217, 0.2);\n      border: 1px solid rgb(124, 102, 217);\n    }\n    .item5 {\n      background: rgba(255, 0, 128, 0.2);\n      border: 1px solid rgb(255, 0, 128);\n    }\n    .item6 {\n      background-color: #fafaf8;\n      border: 1px solid rgb(79, 79, 79);\n    }\n  }\n  .itemsContainerInDetails {\n    // display: flex;\n    justify-content: center;\n    // align-items: center;\n    #{$rtl} & {\n      margin-inline-start: 0;\n    }\n  }\n  :global {\n    .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\n      height: 272px;\n    }\n  }\n}\n\n.MapHeight {\n  height: 732px;\n  margin-bottom: 30px;\n  :global {\n    .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\n      height: 732px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `DotsMap_scroll__QNSSh`,
	"DotsMap": `DotsMap_DotsMap__KSrPu`,
	"TopBar": `DotsMap_TopBar__K5N8J`,
	"Filters": `DotsMap_Filters__xWH4u`,
	"Controls": `DotsMap_Controls__FtiR2`,
	"ControlsItem": `DotsMap_ControlsItem__Bsjym`,
	"itemsContainer": `DotsMap_itemsContainer__jdlPj`,
	"item1": `DotsMap_item1__gLTey`,
	"item2": `DotsMap_item2__n56wU`,
	"item3": `DotsMap_item3__15B8n`,
	"item4": `DotsMap_item4__HplEh`,
	"item5": `DotsMap_item5__OIxpL`,
	"item6": `DotsMap_item6__Nf58+`,
	"itemsContainerInDetails": `DotsMap_itemsContainerInDetails__PO9El`,
	"MapHeight": `DotsMap_MapHeight__NOxz3`
};
export default ___CSS_LOADER_EXPORT___;
